import React from 'react';
import './Admin.scss';
import AdminMenu from "./AdminMenu/AdminMenu";
import AdminView from "./AdminView/AdminView";
import { closeInputFormsForNote } from './adminSlice';

export default class Admin extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
        adminQuizersView: false,
        adminUsersView: false,
        adminLibraryView: false,
        adminTasksView: false,
        }
       
        this.handlerAdminView = this.handlerAdminView.bind(this);
        this.handleAdminQuizesView = this.handleAdminQuizesView.bind(this);
        this.handleAdminTasksView = this.handleAdminTasksView.bind(this);
    }

//SHOW AdminID COMPONENT
handlerAdminView(id) {
  const { dispatch} = this.props;
    if (id === "1") {
        this.setState(
            { 
              adminUsersView: false,
              adminQuizersView: true,
              adminLibraryView: false,
              adminTasksView: false
            }
      
          )
    } else if (id === "2") {
      dispatch(closeInputFormsForNote());
        this.setState(
            { 
              adminUsersView: true,
              adminQuizersView: false,
              adminLibraryView: false,
              adminTasksView: false
            }
      
          )  
    } else if (id === "3") {
      dispatch(closeInputFormsForNote());
      this.setState(
          { 
            adminUsersView: false,
            adminQuizersView: false,
            adminLibraryView: true,
            adminTasksView: false

          }
    
        )  
  } else if (id === "4") {
      dispatch(closeInputFormsForNote());
      this.setState(
          { 
            adminUsersView: false,
            adminQuizersView: false,
            adminLibraryView: false,
            adminTasksView: true

          }
    
        )  
  } 

  }
  //CLOSE ADMIN QUIZES for close when note opens
  handleAdminQuizesView() {
    this.setState(
      {
        adminQuizersView: !this.state.adminQuizersView,
      }
    )
  }

  //CLOSE TASK VIEW
  //CLOSE ADMIN QUIZES for close when note opens
  handleAdminTasksView() {
    this.setState(
      {
        adminTasksView: !this.state.adminTasksView,
      }
    )
  }

    render() {
      const { dispatch} = this.props;
      
        return (
            
            <div className="Admin">
                    <AdminMenu 
                    handlerAdminView ={this.handlerAdminView}
                    closeAdminView={this.props.closeAdminView}
                    authData={this.props.authData}
                    dispatch={dispatch}
                    />
                    <AdminView 
                    viewUsers={this.state.adminUsersView} 
                    viewQuizers={this.state.adminQuizersView}
                    viewLibrary={this.state.adminLibraryView}
                    viewTasks={this.state.adminTasksView} 
                    userId={this.props.authData.id}
                    adminUsersState={this.props.adminUsersState}
                    adminState={this.props.adminState}
                    libraryData={this.props.libraryData}
                    dispatch={dispatch}
                    authData={this.props.authData}
                    handleAdminQuizesView={this.handleAdminQuizesView}
                    handleAdminTasksView={this.handleAdminTasksView}
                    tasksDataMain={this.props.tasksDataMain} 
                    />
                    
                    


                
            </div>
        )
    }
}